import { useEffect, useState } from 'react';

import { useExecutionsUIStore } from '@core/useStores';

/**
 * Exchanges an execution media URL for a playable one via the ExecutionMedias
 * resolver (pre-signed URL for private S3 media, the same URL otherwise).
 * Returns null while resolution is pending or when disabled.
 */
export function useResolvedMediaUrl(mediaUrl: string | null | undefined, enabled: boolean = true): string | null {
    const executionsUIStore = useExecutionsUIStore();
    const [resolvedUrl, setResolvedUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!enabled || !mediaUrl) {
            setResolvedUrl(null);
            return;
        }

        let isCancelled = false;

        const resolve = async () => {
            const url = await executionsUIStore.execution.resolveMediaUrl(mediaUrl);

            if (!isCancelled) {
                setResolvedUrl(url);
            }
        };

        void resolve();

        return () => {
            isCancelled = true;
        };
    }, [mediaUrl, enabled, executionsUIStore]);

    return resolvedUrl;
}
